export default function preloaderGame1 (scene) {

    scene.load.image(`tilesgame1`, `/tiles/game1.png`);
    scene.load.image(`noLightstickgame1`, `/tiles/noLightstick-game1.png`);
    scene.load.image('dialog-test', `/img/generalSprites/Dislogos.png`);

	scene.load.audio("chasemeSong", ["/audio/songs/1-chaseme.mp3"]);


	scene.load.spritesheet(`jiu-game1`, 
		`/img/game1/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game1`, 
		`/img/game1/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game1`, 
		`/img/game1/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game1`, 
		`/img/game1/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game1`, 
		`/img/game1/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game1`, 
		`/img/game1/dami.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game1`, 
		`/img/game1/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`enemy-game1`, 
		`/img/game1/enemy.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`humo-game1`, 
	`/img/generalSprites/humo-infinite.png`,
		{ frameWidth: 41, frameHeight: 42}
	);

	scene.load.tilemapTiledJSON(`game1`, `/tiles/game1.tmj`);

}